module.exports = __webpack_public_path__ + "static/media/id.1a2f72a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/id.svg
// module id = 146
// module chunks = 0